var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.projectTypeCode !== '--')?_c('v-row',{staticClass:"px-2 py-1"},[_c('span',{staticClass:"type-badge",style:(_vm.badgeStyle)},[_vm._v(" "+_vm._s(_vm.projectTypeCode)+" ")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }